export default {
  "languageDisplayName": "Français",
  "greeting": "Bonjour",
  "Profile": "Profil",
  "Interests": "Intérêts",
  "Recurring Payments": "Paiements Récurrents",
  "Payment Methods": "Méthodes De Payement",
  "Transactions": "Transactions",
  "Passport": "Passeport",
  "Wallet": "Portefeuille",
  "Subscriptions": "Abonnements",
  "Projects": "Projets",
  "Campaigns": "Campagnes",
  "Volunteer": "Bénévole",
  "Events": "Événements",
  "Settings": "Paramètres",
  "My": "Mes",
  "Groups": "Groupes",
  "Awards": "Prix",
  "Change": "Changer",
  "Image": "Image",
  "You have no": "Vous n'avez pas",
  "Now": "Maintenant",
  "Booths": "Cabines",
  "You don't have any listed": "Vous n'avez pas de liste",
  "Add": "Ajoute",
  "You Might Like:": "Tu pourrais aimer: ",
  "Start Date": "Date de début",
  "End Date": "Date de fin",
  "Payment Method": "Mode de paiement",
  "Filter": "Filtre",
  "Download": "Télécharger",
  "Saved Cards": "Cartes Sauvegardées",
  "Saved Debits": "Débits Enregistrés",
  "Recommended": "Recommandés",
  "Subscribe": "Souscrire",
  "Unsubscribe": "Se Désabonner",
  "Click to": "Cliquez Pour",
  "Update": "Mettre à jour",
  "Register": "Registre",
  "Unregister": "Annuler l'inscription",
  "Add More Interests": "Ajouter plus d'intérêts",
  "Add More Skills": "Ajouter plus de compétences",
  "Search": "Chercher",
  "Close": "Fermer",
  "Credit Card": "Carte de crédit",
  "credit": "Carte de crédit",
  "Debit": "Débit",
  "debit": "Débit",
  "Cancel": "Annuler",
  "Save": "Sauvegarder",
  "Account Name": "Nom du compte",
  "Institution Name": "Nom de l'institution",
  "BSB Number": "Numéro BSB",
  "Account Number": "Numéro de Compte",
  "Cardholder Name": "Nom du Titulaire",
  "Card Number": "Numéro de Carte",
  "Expiration Date": "Date d'expiration",
  "Cannot Be Empty": "Ne peux pas être vide",
  "Not Valid": "Pas Valide",
  "Cannot Be Empty or Contain Numbers": "Ne peut pas être vide ou contenir des nombres",
  "Login": "Connexion",
  "Logout": "Déconnexion",
  "Offline": "Hors Ligne",
  "No Popups": "Nous avons remarqué que vous avez bloqué les fenêtres pop-up, assurez-vous que vous les avez activé pour cette",
  "Awaiting Login": "En attente de connexion",
  "Awaiting Registration": "En attente d'inscription",
  "Please": "Please",
  "Voting": "Vote",
  "Site Settings": "Paramètres du site",
  "My Settings": "Mes paramètres",
  "Security Settings": "Les paramètres de sécurité",
  "2-Factor Authentication": "Authentification à 2 facteurs",
  "Language": "La langue",
  "Name": "Prénom",
  "Addresses": "Adresses",
  "Work": "Travail",
  "Home": "Accueil",
  "Other": "Autre",
  "Phone Numbers": "Les numéros de téléphone",
  "Email Addresses": "Adresses mail",
  "First Name": "Prénom",
  "Last Name": "Nom de famille",
  "Address Type": "Type d'adresse",
  "Street Address 1": "Adresse 1",
  "Street Address 2": "Adresse 2",
  "City": "Ville",
  "State": "Etat",
  "Postcode": "Code postal",
  "Country": "Pays",
  "Phone Number Type": "Type de numéro de téléphone",
  "Email Type": "Type de courriel",
  "Custom Type": "Type personnalisé",
  "Number": "Nombre",
  "Email": "Email",
  "Emails": "E-mails",
  "Phone": "Téléphone",
  "Phones": "Téléphones",
  "Address": "Adresse",
  "Add Address": "Ajouter une adresse",
  "Add Phone": "Ajouter un téléphone",
  "Add Email": "Ajouter une adresse e-mail",
  "Accommodation": "Hébergement",
  "Mobile": "Mobile",
  "View": "Vue",
  "No Groups": "Vous n'avez aucun groupe",
  "Recommended Groups": "Groupes recommandés",
  "Roles": "Les rôles",
  "Admin": "Admin",
  "Photos": "Photos",
  "Join": "Joindre",
  "Leave": "Partir",
  "Joined": "Rejoint",
  "Member": "Membre",
  "Members": "Membres",
  "Are you sure?": "Êtes-vous sûr?",
  "Yes": "Oui",
  "No": "Non",
  "Fitness": "Aptitude",
  "Help": "Aidez-moi",
  "Gallery": "Galerie",
  "Support": "Soutien",
  "Unsupport": "Ne Pas Supporter",
  "Skills": "Compétences",
  "Communities": "Communautés",
  "Click here to enter": "Cliquez ici pour entrer",
  "Rooms": "Pièces",
  "Boards": "Planches",
  "Cloud": "Nuage",
  "Future": "Avenir",
  "Churches": "Des églises",
  "Password": "Mot de passe",
  "password": "mot de passe",
  "New Password": "Nouveau mot de passe",
  "Old Password": "Ancien mot de passe",
  "Confirm Password": "Confirmez le mot de passe",
  "Subscribers": "Les abonnés",
  "Browse": "Feuilleter",
  "Past Events": "Évènements Passés",
  "Future Events": "Événements à Venir",
  "Create": "Créer",
  "Edit": "Modifier",
  "Issues": "Problèmes",
  "Organizer": "Organisateur",
  "Next": "Suivant",
  "Back": "Retour",
  "Confirm": "Confirmer",
  "Select Payment Method": "Sélectionnez Le Mode De Paiement",
  "Please provide a payment method": "S'il vous plaît fournir un moyen de paiement",
  "Select A Support Level": "Sélectionnez Un Niveau De Soutien",
  "Your support will be sent from your selected payment method:": "Votre support sera envoyé à partir du mode de paiement sélectionné:",
  "My Gallery": "Ma Galerie",
  "Local Artists": "Artistes Locaux",
  "My Fitness": "Ma Forme Physique",
  "Next Due": "Prochaine échéance",
  "Frequency": "La Fréquence",
  "Status": "Statut",
  "Link Your Fitbit": "Liez Votre Fitbit",
  "Link Your Strava": "Liez Votre Strava",
  "Active": "Actif",
  "Cancelled": "Annulé",
  "Tracker": "Traqueur",
  "Mobile Number": "Numéro De Portable",
  "Day": "Journée",
  "Month": "Mois",
  "Year": "Année",
  "Date Of Birth": "Date de Naissance",
  "Sign Up": "S'inscrire",
  "Check In": "Enregistrement",
  "News": "Nouvelles",
  "Deregister": "Désinscrire",
  "What's On": "Quoi de neuf",
  "On Now": "Maintenant",
  "Coming Up": "Bientôt",
  "There are currently no upcoming events": "Il n'y a aucun évènement à venir",
  "Next Up": "Suivant",
  "Near Me": "Près de moi",
  "Goals": "Buts",
  "Connect": "Relier",
  "Select An Option": "Choisis Une Option",
  "Mentors": "Mentors",
  "Employment": "Emploi",
  "Log In": "S'identifier",
  "Log Out": "Déconnexion",
  "Please log in or sign up to continue.": "Veuillez vous connecter ou vous inscrire pour continuer.",
  "Add your group": "Ajouter votre groupe",
  "Preferred": "Préféré",
  "Read More": "Lire la suite",
  "Description": "La Description",
  "Submit": "Soumettre",
  "Subject": "Matière",
  "Message": "Message",
  "Send Me A Copy": "Envoie-moi Une Copie",
  "Contacts": "Contacts",
  "Followers": "Suiveuses",
  "Follow": "Suivre",
  "Following": "Suivante",
  "Contact Number": "Numéro De Contact",
  "Any unsaved information may be lost": "Toute information non enregistrée peut être perdue",
  "Add Location": "Ajouter un emplacement",
  "Edit Location": "Modifier l'emplacement",
  "Last Logged In": "Dernière connexion",
  "Your Connections": "Vos connexions",
  "There are no connections currently linked to your account": "Aucune connexion n'est actuellement liée à votre compte",
  "Connection Type": "Type de connexion",
  "Remove Connection": "Supprimer la connexion",
  "Connect To: ": "Connectez-vous à: ",
  "Timezone": "Fuseau horaire",
  "forgotPassword": "Je ne connais pas mon mot de passe",
  "createNewAccount": "Créer un nouveau compte",
  "logInWith": "Se connecter avec",
  "orEnterYour": "ou utilisez votre",
  "usernameOrEmail": "nom d'utilisateur ou votre e-mail",
  "passwordRequired": "mot de passe requis",
  "enterPasswordFor": "tapez le mot de passe pour",
  "authenticationFailed": "authentification échouée",
  "signIn": "s'identifier",
  "iHaveAnAccount": "j'ai un compte",
  "termsAndPrivacy": "termes et confidentialité",
  "securedBy": "sécurisé par",
  "Delete": "Effacer",
  "Please Wait": "S'il vous plaît, attendez",
  "loadingDiscussions": "Nous chargeons vos discussions de chat!",
  "No Discussions": "Aucune discussion!",
  "joinDiscussion": "Joignez-vous à une discussion pour qu'elle s'affiche ici!",
  "Discussion": "Discussion",
  "Log in with :": "Connectez-vous avec:",
  "Powered By:": "Propulsé par:",
  "termsUpdated": "Veuillez accepter les dernières conditions et la politique de confidentialité",
  "Please accept the latest": "Veuillez accepter la dernière",
  "Terms": "Termes",
  "terms": "termes",
  "Privacy Policy": "Politique de Confidentialité",
  "privacy policy": "politique de confidentialité",
  "willRecieveFollowingInfo": "recevra les informations suivantes :",
  "Email Address": "Adresse Email",
  "and": "et",
  "We Use Cookies": "Nous utilisons des cookies",
  "Cookies help us handle many processes our platform requires, please accept or review our available settings": "Les cookies nous aident à gérer de nombreux processus requis par notre plateforme, veuillez accepter ou revoir nos paramètres disponibles",
  "ACCEPT ALL": "ACCEPTER TOUT",
  "REJECT ALL": "TOUT REJETER",
  "ACCEPT CURRENT SELECTION": "ACCEPTER LA SÉLECTION ACTUELLE",
  "SETTINGS": "PARAMÈTRES",
  "Manage cookie preferences": "Gérer les préférences en matière de cookies",
  "Close modal": "Fermer modale",
  "Strictly Necessary cookies": "Cookies strictement nécessaires",
  "These cookies are essential for the proper functioning of the website and cannot be disabled.": "Ces cookies sont indispensables au bon fonctionnement du site et ne peuvent pas être désactivés.",
  "Performance and Analytics": "Performances et Analyses",
  "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.": "Ces cookies collectent des informations sur la façon dont vous utilisez notre site Web. Toutes les données sont anonymisées et ne peuvent pas être utilisées pour vous identifier.",
  "ACCEPT REQUIRED": "ACCEPTATION OBLIGATOIRE",
  "Terms and Privacy Policy Links": "Termes et liens vers la politique de confidentialité",
  "Services": "Prestations de service",
  "Profile Pages": "Pages de profil",
  "Success": "Succès",
  "Your disconnection request has successfully been processed": "Votre demande de déconnexion a été traitée avec succès",
  "Disconnecting will cause a new authorization prompt on next login to any related services": "La déconnexion entraînera une nouvelle invite d'autorisation lors de la prochaine connexion à tous les services associés",
  "Legal": "Légale",
  "Available Services": "Services Disponibles",
  "Link": "Lien",
  "Disconnect": "Déconnecter",
  "Agreed": "Convenu"
};